export const MAKE_BET = 'MAKE_BET';
export const SUCCESS_MAKE_BET = 'SUCCESS_MAKE_BET';
export const FAILURE_MAKE_BET = 'FAILURE_MAKE_BET';



// WEBPACK FOOTER //
// ./js/actions/MakeBet.js